import HeartIcon from '@/assets/Onboarding/HeartIcon.svg';
import ChatIcon from '@/assets/Onboarding/ChatIcon.svg';
import BulbIcon from '@/assets/Onboarding/BulbIcon.svg';
import { Button } from '@/components/ui/button';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { PatientPageLayout } from '@/components/PatientPageLayout';

const cards = [
  {
    icon: HeartIcon,
    iconAlt: 'Coeur',
    title: 'Faites équipe avec votre médecin',
    description:
      'Une consultation anticipée favorise un\néchange qualitatif et un suivi adapté.',
  },
  {
    icon: ChatIcon,
    iconAlt: 'Discussion',
    title: 'Des échanges plus utiles',
    description:
      "En s'organisant en avance, la consultation\ncommence par ce qui compte vraiment.",
  },
  {
    icon: BulbIcon,
    iconAlt: 'Ampoule',
    title: "N'oubliez plus rien",
    description:
      'Vos questions importantes comme\nles bons documents à apporter.',
  },
];

export const WhyPrepareConsultation = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <h1 className="nxs:text-center text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight text-indigo-900">
          Une consultation <br /> mieux préparée, <br /> ça change tout
        </h1>
      }
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Commencer
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col items-center gap-12 nsm:gap-14 py-4">
        <div className="flex w-full flex-col nsm:items-center gap-3">
          {cards.map(({ icon, iconAlt, title, description }) => (
            <div
              key={title}
              className="flex flex-col items-center gap-1 rounded-3xl bg-white/65 py-4 pl-4 pr-3 nlg:p-4.5 nsm:px-4 max-w-85.5 nlg:max-w-88 w-full"
            >
              <div className="flex items-center justify-start h-full gap-3 nlg:gap-4 w-full">
                <img src={icon} alt={iconAlt} className="size-6" />
                <p className="font-semibold leading-[1.2] text-indigo-900">
                  {title}
                </p>
              </div>
              <p className="text-sm leading-[1.3] text-gray-500 whitespace-pre-line w-full ml-18 nlg:ml-20">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </PatientPageLayout>
  );
};
